import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		button: {
			paddingLeft: 15,
			paddingRight: 15,
			// Match heights across the outlined Cancel and contained Add User buttons at the medium
			// (36px) size — the outlined variant's 1px border otherwise renders it slightly shorter.
			minHeight: 36,
		},
		closeButton: {
			position: "absolute",
			right: 8,
			top: 8,
			// The dialog header is white (theme MuiDialogTitle override), so the legacy white
			// icon was invisible. Match the refreshed lead-routing dialogs.
			color: theme.palette.custom.textSecondary,
		},
		titleDivider: {
			marginTop: theme.spacing(2),
		},
		// Sits outside the scrolling DialogContent so the buttons stay pinned (MAX-4060).
		dialogActions: {
			padding: "16px 24px",
			borderTop: `1px solid ${theme.palette.divider}`,
			backgroundColor: theme.palette.background.paper,
		},
		body: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(3), // Figma: 24px between sections
		},
		errorMessage: {
			color: theme.palette.error.main,
			fontSize: "0.75rem",
			fontWeight: "bold",
		},
		iconContainer: {
			display: "flex",
			justifyContent: "center",
		},
		toolTip: {
			fontSize: 14,
		},
		warningBanner: {
			marginBottom: theme.spacing(2),
			border: "1px solid #F9C266",
		},
		pricingLink: {
			color: "inherit",
			fontWeight: "bold",
			display: "inline-flex",
			alignItems: "center",
			gap: 4,
		},
		sectionTitle: {
			fontSize: 16, // override global subtitle1 (10px) — Figma section headers are 16px bold
			lineHeight: "24px",
			fontWeight: 700,
			marginBottom: theme.spacing(2), // Figma: 16px title → content
		},
		sectionDivider: {
			// The parent `body` already contributes 24px of gap on each side of the divider,
			// so the section wrapper only needs the divider's own bottom spacing.
			marginBottom: theme.spacing(3),
		},
		checkboxOption: {
			alignItems: "flex-start",
			marginBottom: theme.spacing(2),
			marginLeft: 0,
			"&:last-child": {
				marginBottom: 0,
			},
			// Figma: 16px between the checkbox control and its label block.
			"& .MuiFormControlLabel-label": {
				marginLeft: theme.spacing(2),
			},
		},
		checkboxControl: {
			padding: 0,
			marginTop: 2, // optical alignment with the bold title line
			color: theme.palette.custom.primary, // brandOrange outline / fill
			"& svg": {
				fontSize: 24,
			},
			"&.Mui-checked": {
				color: theme.palette.custom.primary,
			},
		},
		checkboxOptionTitle: {
			fontWeight: 700,
		},
		checkboxOptionDescription: {
			color: theme.palette.text.secondary,
		},
		leadRoutingLink: {
			display: "inline-flex",
			alignItems: "center",
			gap: 4,
			verticalAlign: "middle",
		},
		dialogPaper: {
			maxWidth: 560,
			width: "100%",
		},
	} satisfies Record<string, CSSObject>);
};
